const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=reviewsDecisions]');
const agreeBt = document.querySelector('#filmConsider_card').querySelector('button[name=agreeRequest]');
const counterAgree = document.querySelector('#filmConsider_card').querySelector('h1[name=countAgreeReviewPoints]');
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index) {

    let answerStr = 'Нет оценки';
    let classNametype = 'review_unknown';
    if( item.reviewValue && parseInt(item.reviewValue, 10) === 1){
      classNametype = 'review_reject';
      answerStr = 'Отказ';
    } else if (parseInt(item.reviewValue, 10) === 2){
      classNametype = 'review_wait';
      answerStr = 'Ожидаю ответ';
    } else if (parseInt(item.reviewValue, 10) === 3){
      classNametype = 'review_wait';
      answerStr = 'Есть замечания';
    } else if (parseInt(item.reviewValue, 10) === 4){
      classNametype = 'review_wait';
      answerStr = 'Думаю';
    } else if (parseInt(item.reviewValue, 10) === 5){
      classNametype = 'review_agree';
      answerStr = 'Одобряю';
    }

    return `<div class="row w-100 p-0"> <b class="review_cloud ${classNametype} w-30" >${answerStr}</b><div class=" p-1 m-1">${item.name} </div>  </div>`

  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay) {

    // console.log(dataToDisplay);
    this.cleanContainer();

    agreeBt.disabled = false;
    counterAgree.innerHTML = '';
    let counterDisaree = dataToDisplay.length;
          
    if(dataToDisplay){
      let reviewsLogs = '';
      let needRevieesPannel = false;

      let currentAnswer = 3;
      dataToDisplay.forEach((item, index) => {
        if(parseInt(item.reviewValue, 10) != 5) {
          agreeBt.disabled = true;
          --counterDisaree;
        } 
         //
        if(parseInt(auth.data.operatorId, 10) === parseInt(item.uid,10)){
          currentAnswer = parseInt(item.reviewValue, 10);
          needRevieesPannel = true;
        }
        reviewsLogs += this.getElement(item, index);
      });
      if (needRevieesPannel) {
        needRevieesPannel = `<div class="w-100 row m-0 p-1 commentCloud"> 
                              <b class="w-100 txt-al-center">Укажите ваше решение:</b>
                              <div class="w-50 p-3" >
                                <div reviewValue = 1  class="review_bt review_reject ${(currentAnswer === 1) ? 'current_review_answer':''}"> Отказ</div> 
                              </div>
                              <div name="bt"class="w-50 p-3">
                                <div  reviewValue = 3  class="review_bt review_wait  ${(currentAnswer === 3) ? 'current_review_answer':''}">
                                Есть замечания</div>
                              </div> 
                              <div name="bt"   class="w-50 p-3" >
                                <div reviewValue = 4 class="review_bt review_wait ${(currentAnswer === 4) ? 'current_review_answer':''}">
                                Думаю</div>
                              </div>
                              <div name="bt" class="w-50 p-3" >
                                <div   reviewValue = 5  class="review_bt review_agree ${(currentAnswer === 5) ? 'current_review_answer':''}">
                                Одобряю</div>
                              </div> 

                              </div>`; 
      } else 
        needRevieesPannel = '';

      let htmlBodyReviews = `<div class ="row w-100 m-0 p-1">
                              <div class ="column w-60 m-0 p-1">
                              ${reviewsLogs}
                              </div>
                              <div class ="column w-40 m-0 p-1">
                              ${needRevieesPannel}
                              </div>

                            </div>`;

      htmlBody.innerHTML = htmlBodyReviews;
      counterAgree.innerHTML = `${counterDisaree}/${dataToDisplay.length}`;
    }
    else
      htmlBody.innerHTML = `<div class = "commentCloud row "}>
            <b class="m-0 p-0 w-100">Ответственные за проверку пока не назначены</b>
           </div>`;
  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
